const BASE_URL = 'https://cool-flower-8eca.igorvyshnevyy.workers.dev'

export type FormEndpoint = 'service' | 'resume'

export async function submitForm(
  endpoint: FormEndpoint,
  formData: FormData,
  language: string,
): Promise<{ ok: boolean; errorDetail?: string }> {
  // Add meta fields
  const productionDomain = 'https://elvora.consulting'
  const currentPath = window.location.pathname
  const pageUrl = productionDomain + currentPath

  formData.append('pageUrl', pageUrl)
  formData.append('language', language)
  formData.append('source', endpoint)

  const referer = document.referrer || ''
  if (referer) {
    formData.append('referer', referer)
  }

  const url = `${BASE_URL}/webhook/${endpoint}`

  console.log(`[ELVORA Form] Submitting to: ${url}`)
  console.log(
    `[ELVORA Form] Fields:`,
    [...formData.entries()].map(
      ([k, v]) =>
        `${k}=${v instanceof File || v instanceof Blob ? `[File: ${v.name}, ${v.size}b]` : v}`,
    ),
  )

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    })

    const body = await response.text().catch(() => '(could not read body)')

    console.log(
      `[ELVORA Form] Response: status=${response.status}, ok=${response.ok}, body=${body}`,
    )

    if (response.ok) {
      return { ok: true }
    } else {
      console.error(
        `[ELVORA Form] Endpoint "${endpoint}" failed: ${response.status} — ${body}`,
      )
      return { ok: false, errorDetail: `Server returned ${response.status}` }
    }
  } catch (err: any) {
    console.error(`[ELVORA Form] Fetch threw:`, err?.message || err)
    return { ok: false, errorDetail: err?.message || 'Network error' }
  }
}
